import { Button } from "@datapay-by-datacom/design-system";
import { useAuthenticated } from "../../authn";
import { getAuth0LogoutReturnTo } from "../functions";
import styles from "./SessionExpired.module.css";

export function SessionExpired() {
  const { logout } = useAuthenticated();

  const handleLogout = () => {
    logout({
      logoutParams: {
        returnTo: getAuth0LogoutReturnTo(),
      },
    });
  };

  return (
    <div className={styles.container}>
      <p>Your session has expired</p>
      <Button onPress={handleLogout} variant="secondary">
        Return to Login
      </Button>
    </div>
  );
}
